module.exports = __webpack_public_path__ + "static/media/Logo_Animado_Sttelar_Atomo_Fundo_Branco.b7d0dd98.mp4";